import React from 'react'
import { BaseSvgIcon, BaseSvgIconProps } from '../kickoff-icons/base-svg-icon'

export const ArrowRightIcon = ({
  className,
  color = '#FFFFFF',
  size,
  title,
  width = 19,
  height = 12,
  strokeWidth = 2.2,
  ...rest
}: BaseSvgIconProps) => {
  return (
    <BaseSvgIcon
      className={className}
      fill="none"
      size={size}
      viewBox="0 0 13 7"
      width={width}
      height={height}
      {...rest}>
      <path
        d="M1.59998 3.69995C5.50522 3.69995 7.21854 3.69995 11.1238 3.69995M11.1238 3.69995L8.62379 1.19995M11.1238 3.69995L8.62379 6.19995"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSvgIcon>
  )
}
